import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import dayjs from "dayjs"
// import { TApiResponse } from "../service/TApiResponse"
import { showWarningToast } from "../components/CustomToast"
import dateUtil from "../ts/util/dateUtil"
import CONST from "../constant/"
import SystemService from "../service/system/systemService"
import KyuzituService from "../service/master/kyuzitu/kyuzituService"
import { TKyuzituListGetRes } from "../service/master/kyuzitu/TKyuzitu"

/**
 * 営業日付を取得
 */
export const getToday = createAsyncThunk<string>("date/getToday", async () => {
  // 日付取得
  try {
    const res = await new SystemService().get()
    return res.data
    //throw new Error("エラーテスト")
  } catch (error) {
    throw error
  }
})

export const get休日List = createAsyncThunk<TKyuzituListGetRes[]>(
  "date/getKyuzituList",
  async () => {
    try {
      const res = await new KyuzituService().getAll()
      if (res && res.data) {
        return res.data
      }
      return []
    } catch (error) {
      throw error
    }
  }
)

// ローカルストレージより初期設定の営業日を取得
const str営業日 =
  localStorage[CONST.LOCALSTORAGE_PROPERTIES.EIGYOBI] ??
  dateUtil.format(new Date())
const str翌営業日 =
  localStorage[CONST.LOCALSTORAGE_PROPERTIES.YOKUEIGYOBI] ??
  dateUtil.toNextEigyobiStr(new Date())
const str翌々営業日 =
  localStorage[CONST.LOCALSTORAGE_PROPERTIES.YOKUYOKUEIGYOBI] ??
  dateUtil.toNextEigyobiStr(dateUtil.toNextEigyobi(new Date()))
const str前月 =
  localStorage[CONST.LOCALSTORAGE_PROPERTIES.ZENGETU] ??
  dateUtil.toZenNenGetsuStr(new Date(), "YYYY/MM")

const initialState: {
  eigyobiStr: string
  yokueigyobiStr: string
  yokuyokueigyobiStr: string
  zengetuStr: string
  休日List: TKyuzituListGetRes[]
} = {
  eigyobiStr: str営業日,
  yokueigyobiStr: str翌営業日,
  yokuyokueigyobiStr: str翌々営業日,
  zengetuStr: str前月,
  休日List: [],
}

export const dateSlice = createSlice({
  name: "date",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 当時取得
      .addCase(getToday.fulfilled, (state, action) => {
        const newState = {
          ...state,

          eigyobiStr: dateUtil.format(action.payload),
          yokueigyobiStr: dateUtil.format(
            dayjs(action.payload).add(1, "d").toDate()
          ),
          yokuyokueigyobiStr: dateUtil.format(
            dayjs(action.payload).add(2, "d").toDate()
          ),
          zengetuStr: dateUtil.format(
            dayjs(action.payload).subtract(1, "M").toDate()
          ),
        }

        //取得した最新営業日をlocalstarageに詰めなおし
        localStorage[CONST.LOCALSTORAGE_PROPERTIES.EIGYOBI] =
          newState.eigyobiStr
        localStorage[CONST.LOCALSTORAGE_PROPERTIES.YOKUEIGYOBI] =
          newState.yokueigyobiStr
        localStorage[CONST.LOCALSTORAGE_PROPERTIES.YOKUYOKUEIGYOBI] =
          newState.yokuyokueigyobiStr
        localStorage[CONST.LOCALSTORAGE_PROPERTIES.ZENGETU] =
          newState.zengetuStr
        return newState
      })
      .addCase(getToday.rejected, (state, action) => {
        showWarningToast(["最新の営業日付をサーバーより取得できませんでした。"])
        throw action.error
      })
      .addCase(get休日List.fulfilled, (state, action) => {
        state.休日List = [...action.payload]
      })
      .addCase(get休日List.rejected, (state, action) => {
        showWarningToast(["休日一覧を取得できませんでした。"])
        throw action.error
      })
  },
})

// export const {} = dateSlice.actions
